import { Injectable } from "@angular/core";
import { HandbookHeaderExtension } from "@geolib/geoappbase-client";
import { HandbookBackToAppComponent } from "./handbook-back-to-app.component";


@Injectable({ providedIn: "root" })
export class HandbookBackToAppExtension extends HandbookHeaderExtension<HandbookBackToAppComponent> {

    public isEnabled(): boolean {
        return true;
    }

    public get component(): typeof HandbookBackToAppComponent {
        return HandbookBackToAppComponent;
    }

}
